<template>
  <main role="main" class="container py-5">
    <b-form-group label="Email" label-for="input-email">
      <b-form-input id="input-email" type="email" v-model="email" :state="validationState"></b-form-input>
    </b-form-group>
  </main>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as validationUtils from "@/service/validationUtils";

  @Component
  export default class TestValidateEmail extends BaseComponent {

    email = "";

    mounted() {

    }

    get validationState(): boolean {
      return validationUtils.isEmail(this.email);
    }

  }
</script>
